import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Set REACT_APP_GA_ID (e.g. G-XXXXXXXXXX) per client; without it no analytics script loads
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID;

function loadGtag(id) {
  if (window.gtag) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
}

export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (!GA_MEASUREMENT_ID) return;
    loadGtag(GA_MEASUREMENT_ID);
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null; // This component doesn't render anything
}
